import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import {
  UserActionTypes,
  RequestInvitationLink,
  RequestInvitationLinkSuccess,
  RequestInvitationLinkFailure,
} from './user.actions';
import { ToastrService } from 'ngx-toastr';
import { InvitationLinkService } from '../../services/invitation-link.service';

@Injectable()
export class UserEffects {
  @Effect()
  requestInvitationLink$ = this.actions$.pipe(
    ofType(UserActionTypes.REQUEST_INVITATION_LINK),
    exhaustMap(({ payload }: RequestInvitationLink) =>
      this.invitationLinkService.invitationLink(payload).pipe(
        map(({ invitationLink }) => {
          return new RequestInvitationLinkSuccess(invitationLink);
        }),
        catchError(() => {
          this.toastr.error('Could not generate iinvitation link');
          return [new RequestInvitationLinkFailure()];
        }),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private toastr: ToastrService,
    private invitationLinkService: InvitationLinkService,
  ) {}
}
